var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpaceman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 160,
    viewBox: "0 0 199 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.397 106.113C183.155 104.497 182.858 102.896 182.52 101.314L167.363 108.661L183.397 106.113Z",
    fill: "#D5E6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.468 49.8818C108.468 49.8818 63.6512 67.728 39.4249 76.3843C35.3872 82.8539 32.3214 89.8813 30.3255 97.2417L68.8076 80.4278L38.3573 100.349L60.514 96.4763L59.9601 99.2409L119.733 83.1974L33.3771 122.505L46.661 110.324L27.5811 117.626V117.777C27.5692 127.437 29.3483 137.015 32.8282 146.027L117.512 113.648L71.0032 138.01L154.05 108.109L131.894 113.094L162.903 97.5892H145.767L177.642 86.249C176.591 83.8655 175.43 81.5474 174.158 79.2948L110.331 100.913L169.812 72.4464C162.906 62.7106 153.866 54.6821 143.383 48.9739C132.9 43.2658 121.251 40.0292 109.326 39.5113C97.4011 38.9934 85.5154 41.2079 74.5769 45.9856C63.6385 50.7634 53.9368 57.9781 46.2129 67.0784L108.468 49.8818Z",
    fill: "#D5E6FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.936 139.12C161.526 139.12 174.22 132.403 183.652 127.513C184.448 121.085 184.448 114.584 183.652 108.156L104.246 141.326L125.274 125.272L52.5098 151.845H176.476C178.968 146.688 180.88 141.27 182.177 135.691C175.515 136.995 164.466 139.12 162.936 139.12Z",
    fill: "#D5E6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.392 106.113C183.15 104.497 182.853 102.896 182.516 101.314L167.358 108.661L183.392 106.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.471 49.8818C108.471 49.8818 63.6541 67.728 39.4278 76.3843C35.3902 82.8539 32.3243 89.8813 30.3284 97.2417L68.8106 80.4278L38.3602 100.349L60.5169 96.4763L59.963 99.2409L119.736 83.1974L33.38 122.505L46.664 110.324L27.584 117.626V117.777C27.5722 127.437 29.3513 137.015 32.8311 146.027L117.515 113.648L71.0061 138.01L154.053 108.109L131.897 113.094L162.906 97.5892H145.77L177.645 86.249C176.594 83.8655 175.433 81.5474 174.161 79.2948L110.334 100.913L169.815 72.4464C162.909 62.7106 153.869 54.6821 143.386 48.9739C132.903 43.2658 121.254 40.0292 109.329 39.5113C97.404 38.9934 85.5183 41.2079 74.5799 45.9856C63.6415 50.7634 53.9397 57.9781 46.2158 67.0784L108.471 49.8818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.939 139.125C161.529 139.125 174.223 132.408 183.655 127.518C184.451 121.09 184.451 114.589 183.655 108.161L104.249 141.331L125.277 125.277L52.5127 151.85H176.479C178.971 146.693 180.883 141.275 182.18 135.696C175.517 137 164.469 139.125 162.939 139.125Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0612 27.468C92.431 27.468 98.4055 21.4935 98.4055 14.1237C98.4055 6.75377 92.431 0.779297 85.0612 0.779297C77.6913 0.779297 71.7168 6.75377 71.7168 14.1237C71.7168 21.4935 77.6913 27.468 85.0612 27.468Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.069 151.846H198.105",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3989 151.846H189.042",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0366 151.847L56.8714 129.816C57.0284 129.705 57.2063 129.627 57.3944 129.587C57.5824 129.548 57.7766 129.546 57.9651 129.584C58.1536 129.622 58.3324 129.698 58.4907 129.807C58.649 129.916 58.7833 130.056 58.8856 130.219C59.6863 131.417 58.085 139.832 58.085 139.832L62.4911 140.234L63.2918 143.034L66.0966 145.839L66.4944 151.847H30.0366Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00331 150.916L25.2301 138.498C25.2301 138.498 28.035 138.1 27.6321 140.9C27.2293 143.7 23.226 146.912 23.226 146.912L23.6288 150.115L24.2532 151.847H4L8.00331 150.916Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.732 26.7225L113.371 24.4506C110.964 24.3042 108.895 26.1366 108.748 28.5434L106.242 69.7542C106.096 72.1609 107.928 74.2307 110.335 74.377L147.696 76.649C150.102 76.7954 152.172 74.9629 152.318 72.5562L154.824 31.3454C154.971 28.9386 153.138 26.8689 150.732 26.7225Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.602 46.184C104.602 46.184 101.747 49.709 93.3574 52.2268C84.9681 54.7446 82.9488 56.0891 82.9488 56.0891C82.9488 56.0891 78.0794 57.7659 76.4025 61.9606C74.7256 66.1553 75.7328 68.3407 85.4666 67.671C95.2004 67.0012 115.343 59.1105 115.343 59.1105C115.343 59.1105 119.039 52.393 118.198 46.6876C117.357 40.9823 106.279 43.8324 104.602 46.184Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1523 63.9254C82.1523 63.9254 82.3487 65.844 82.525 67.7877C83.4062 67.7877 84.3781 67.7475 85.4708 67.6719C95.2046 66.9972 115.347 59.1114 115.347 59.1114C116.779 56.3769 117.744 53.4223 118.202 50.3696L117.069 47.1367C117.069 47.1367 111.359 53.5168 105.991 57.2079C100.623 60.899 82.1523 63.9254 82.1523 63.9254Z",
    fill: "#D5E6FB"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.602 46.184C104.602 46.184 101.747 49.709 93.3574 52.2268C84.9681 54.7446 82.9488 56.0891 82.9488 56.0891C82.9488 56.0891 78.0794 57.7659 76.4025 61.9606C74.7256 66.1553 75.7328 68.3407 85.4666 67.671C95.2004 67.0012 115.343 59.1105 115.343 59.1105C115.343 59.1105 119.039 52.393 118.198 46.6876C117.357 40.9823 106.279 43.8324 104.602 46.184Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.291 64.9718C83.291 64.9718 103.338 61.8598 113.263 56.2148",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.165 64.3718C100.759 62.428 101.394 59.0088 100.069 55.5846C99.3733 53.7305 98.0422 52.1834 96.3126 51.2188C95.4112 51.5662 94.4293 51.9036 93.3567 52.2259L92.5762 52.4625C94.3386 53.5452 97.1535 55.8767 97.3852 59.7793C97.5293 61.5926 97.4973 63.4156 97.2895 65.2228C98.2513 64.9458 99.2131 64.6638 100.165 64.3718Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.241 37.9466C117.418 37.1366 116.442 36.4982 115.37 36.0684C108.164 33.329 104.292 41.5622 102.953 47.192C102.953 47.192 104.629 48.5365 108.824 47.8618C113.019 47.187 119.062 44.3368 119.736 41.9852C120.129 40.5198 119.354 39.0746 118.241 37.9466Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2941 57.9345C84.2941 57.9345 84.2941 61.7968 81.6051 62.8039C78.9161 63.811 76.4033 61.963 76.4033 61.963C76.4033 61.963 75.8998 54.5808 76.5695 53.2363C77.2392 51.8918 83.1158 54.7469 84.2941 57.9345Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.68 36.5126C122.68 36.5126 118.148 37.137 117.04 38.5268C115.932 39.9166 109.834 72.9905 109.522 73.9322C109.21 74.8738 110.458 77.8499 114.376 82.0798C118.294 86.3097 123.148 87.5636 127.846 87.8758C132.545 88.188 143.668 85.8615 146.332 83.3437C148.996 80.8259 148.684 74.2544 148.684 70.654C148.684 67.0535 150.094 42.2985 149.152 40.108C148.21 37.9175 142.102 36.0342 141.166 36.0342C140.229 36.0342 123.778 36.3565 122.68 36.5126Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.681 70.6647C148.681 67.0592 150.091 42.3092 149.149 40.1137C148.207 37.9182 142.099 36.0449 141.163 36.0449C140.226 36.0449 123.77 36.3571 122.677 36.5132C121.851 36.6379 121.033 36.806 120.225 37.0168C122.239 40.5417 126.65 45.6982 135.19 46.1363C138.525 46.3466 141.871 45.989 145.085 45.0788L143.247 65.6039L129.007 64.2645L139.551 69.9698L140.226 78.6965L147.83 80.7863C148.852 77.6894 148.681 73.3537 148.681 70.6647Z",
    fill: "#D5E6FB"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M122.68 36.5126C122.68 36.5126 118.148 37.137 117.04 38.5268C115.932 39.9166 109.834 72.9905 109.522 73.9322C109.21 74.8738 110.458 77.8499 114.376 82.0798C118.294 86.3097 123.148 87.5636 127.846 87.8758C132.545 88.188 143.668 85.8615 146.332 83.3437C148.996 80.8259 148.684 74.2544 148.684 70.654C148.684 67.0535 150.094 42.2985 149.152 40.108C148.21 37.9175 142.102 36.0342 141.166 36.0342C140.229 36.0342 123.778 36.3565 122.68 36.5126Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M129.948 71.2777C122.782 71.2777 113.95 60.1994 113.577 59.7462L114.761 58.8096C114.851 58.9204 123.512 69.7671 129.948 69.7671C131.816 69.7671 133.065 69.3189 133.659 68.4326C134.566 67.0831 133.755 65.0034 133.745 64.9832L135.145 64.4092C135.19 64.525 136.278 67.2442 134.913 69.2786C134.022 70.603 132.34 71.2777 129.948 71.2777Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M107.061 74.896C107.499 74.5082 108.068 74.0097 108.571 73.6219C108.169 73.5716 106.003 73.2493 105.399 71.7336C104.795 70.2179 105.741 67.9921 108.063 65.0967C115.148 56.2743 126.438 54.4161 126.554 54.401L126.327 52.835C125.823 52.9105 114.367 54.7888 106.905 64.0845C104.15 67.5138 103.178 70.2934 104.009 72.3479C104.298 72.9715 104.722 73.5233 105.249 73.9639C105.777 74.4044 106.396 74.7227 107.061 74.896Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M128.253 51.9428L125.905 51.8164L125.712 55.4167L128.06 55.543L128.253 51.9428Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M132.703 63.4066L132.561 65.7539L136.16 65.9715L136.302 63.6242L132.703 63.4066Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.853 48.4242L126.911 61.824C126.871 62.4246 127.068 63.017 127.461 63.4731C127.854 63.9292 128.411 64.2123 129.011 64.2612L142.209 65.3036C142.518 65.3276 142.829 65.2884 143.123 65.1884C143.417 65.0885 143.687 64.9298 143.917 64.722C144.148 64.5143 144.333 64.2618 144.463 63.98C144.593 63.6982 144.664 63.393 144.672 63.0829L145.024 49.104C145.039 48.5032 144.816 47.9208 144.404 47.4833C143.992 47.0458 143.424 46.7886 142.823 46.7675L130.234 46.3042C129.639 46.2765 129.057 46.4828 128.612 46.8789C128.166 47.2751 127.894 47.8298 127.853 48.4242Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M133.872 46.4355L133.479 54.9961L137.709 55.3083L138.253 46.5967L133.872 46.4355Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.817 59.2263C143.817 59.7534 143.661 60.2686 143.368 60.7068C143.075 61.145 142.658 61.4864 142.171 61.6879C141.684 61.8894 141.148 61.9418 140.632 61.8386C140.115 61.7354 139.64 61.4812 139.268 61.1082C138.895 60.7351 138.642 60.26 138.54 59.7429C138.438 59.2259 138.491 58.6901 138.693 58.2034C138.896 57.7168 139.238 57.3011 139.677 57.009C140.116 56.7169 140.631 56.5615 141.158 56.5625C141.508 56.5625 141.854 56.6314 142.177 56.7654C142.5 56.8993 142.793 57.0956 143.04 57.343C143.287 57.5905 143.483 57.8842 143.616 58.2073C143.749 58.5305 143.818 58.8768 143.817 59.2263Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6397 69.601C75.6397 69.601 79.4164 70.2707 82.0199 68.3421C84.6233 66.4134 83.1932 62.9691 80.8415 61.0404C78.4899 59.1118 73.7111 58.5226 71.7774 59.4442C69.8438 60.3657 70.8559 63.9762 71.4451 65.9099C72.0342 67.8436 73.0363 69.2636 75.6397 69.601Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5697 7.50293C56.5697 7.50293 58.9415 14.9657 50.5522 19.3316C42.1629 23.6974 38.1293 23.3601 28.3955 29.7351C18.6617 36.1102 16.3101 50.2149 16.3101 50.2149C16.3101 50.2149 18.6567 44.1722 29.735 43.5025C40.8133 42.8327 51.8917 42.3896 56.2575 42.158C62.6377 41.8206 65.9914 38.1295 65.9914 38.1295L56.5697 7.50293Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.669 131.483L56.5746 7.50105C56.5257 7.34302 56.5085 7.17687 56.5241 7.01218C56.5397 6.8475 56.5878 6.68752 56.6655 6.54148C56.7432 6.39544 56.849 6.26622 56.9769 6.16126C57.1047 6.05631 57.2521 5.97769 57.4105 5.92994C57.729 5.83376 58.0726 5.86705 58.3667 6.0226C58.6609 6.17815 58.8818 6.44341 58.9816 6.76081L97.0911 130.753L94.669 131.483Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4514 69.5994C71.4514 69.5994 71.0284 71.1101 72.8765 71.528C74.7245 71.946 77.9121 71.0245 77.7459 69.4332C77.5797 67.842 76.3158 67.4995 74.9763 67.6708C73.6368 67.842 71.4514 68.8441 71.4514 69.5994Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0345 64.398C73.0345 64.398 68.3565 65.1332 68.1601 66.1403C67.9637 67.1474 68.3313 69.494 69.5801 69.8465C70.8289 70.199 74.9632 69.7861 75.7084 68.4516C76.4537 67.1172 75.4265 64.5692 74.4647 64.2922C74.2343 64.1982 73.9853 64.1589 73.7372 64.1772C73.4891 64.1956 73.2486 64.2711 73.0345 64.398Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7334 61.1767C71.7334 61.1767 67.0503 61.9118 66.8539 62.924C66.6575 63.9362 67.0251 66.2727 68.279 66.6252C69.5328 66.9777 73.657 66.5698 74.4073 65.2354C75.1576 63.9009 74.1203 61.3529 73.1635 61.0759C72.9335 60.9816 72.6847 60.9416 72.4367 60.9591C72.1887 60.9765 71.948 61.051 71.7334 61.1767Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M70.751 56.3307C70.751 56.3307 65.6298 56.0387 65.2119 57.0659C64.7939 58.0932 64.6227 60.6463 65.8665 61.3059C67.1103 61.9656 71.5718 62.4792 72.6696 61.2354C73.7674 59.9916 73.2588 57.0659 72.307 56.5523C72.083 56.3964 71.8256 56.2952 71.5553 56.2567C71.2851 56.2182 71.0097 56.2436 70.751 56.3307Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8447 58.4251C77.8447 58.4251 79.1036 55.8519 78.2022 53.9333C77.3008 52.0148 75.3269 52.4226 74.491 53.032C73.9515 53.4422 73.5138 53.9712 73.2119 54.5779C73.2119 54.5779 75.3269 54.5326 76.2333 55.4289C77.1397 56.3252 77.8447 58.4251 77.8447 58.4251Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4474 55.1783C77.3857 54.9276 77.2606 54.6969 77.0843 54.5082C76.908 54.3196 76.6863 54.1793 76.4403 54.1007C75.4332 53.7734 73.7714 53.431 73.2024 54.6042C72.3615 56.2811 72.3615 60.647 74.8793 61.4829C77.3971 62.3188 78.0668 60.3096 77.9006 58.1292C77.8281 57.1351 77.6765 56.1484 77.4474 55.1783Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M148.635 75.6421C145.613 73.4969 139.999 71.4424 134.812 74.7206C129.625 77.9987 129.545 85.3205 129.696 87.8988C134.988 87.6621 143.972 85.5673 146.313 83.3667C147.985 81.7906 148.489 78.6534 148.635 75.6421Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M134.116 110.138C133.697 110.596 133.392 111.149 133.228 111.748C133.065 112.348 133.046 112.979 133.175 113.587C133.643 115.601 133.175 133.322 133.175 133.322C133.175 133.322 133.331 137.551 140.693 138.649C148.055 139.747 150.563 137.708 150.563 137.708C150.563 137.708 150.407 115.465 150.25 112.958C150.175 111.494 149.686 110.081 148.84 108.884L134.116 110.138Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M148.839 108.907L134.114 110.161C133.695 110.62 133.39 111.172 133.227 111.772C133.063 112.372 133.044 113.002 133.173 113.61C133.344 114.341 133.389 117.095 133.379 120.323L147.524 138.783C149.7 138.426 150.546 137.731 150.546 137.731C150.546 137.731 150.389 115.489 150.233 112.981C150.162 111.519 149.679 110.106 148.839 108.907Z",
    fill: "#D5E6FB"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M134.116 110.138C133.697 110.596 133.392 111.149 133.228 111.748C133.065 112.348 133.046 112.979 133.175 113.587C133.643 115.601 133.175 133.322 133.175 133.322C133.175 133.322 133.331 137.551 140.693 138.649C148.055 139.747 150.563 137.708 150.563 137.708C150.563 137.708 150.407 115.465 150.25 112.958C150.175 111.494 149.686 110.081 148.84 108.884L134.116 110.138Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M148.525 77.8668C148.525 77.8668 146.803 75.6713 140.393 75.9835C133.982 76.2957 131.152 83.975 131.329 85.5512C131.505 87.1273 132.421 108.111 133.051 109.833C133.68 111.555 140.881 113.121 146.209 112.185C151.536 111.248 152.005 106.545 151.38 103.251C150.756 99.958 149.814 80.6968 149.814 80.0875C149.814 79.4782 149.306 78.8035 148.525 77.8668Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M151.342 103.244C150.713 99.9555 149.776 80.6893 149.776 80.08C149.776 79.4706 149.303 78.8261 148.522 77.8895C148.19 77.5396 147.793 77.2574 147.354 77.0586L146.599 77.3708C146.599 77.3708 146.936 80.7295 146.936 85.0954C146.936 89.4613 145.929 104.231 145.929 104.231L131.829 88.4491L131.683 92.5229C132.056 99.316 132.6 108.717 133.013 109.845C133.637 111.568 140.843 113.134 146.171 112.197C151.498 111.26 151.972 106.537 151.342 103.244Z",
    fill: "#D5E6FB"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M148.525 77.8668C148.525 77.8668 146.803 75.6713 140.393 75.9835C133.982 76.2957 131.152 83.975 131.329 85.5512C131.505 87.1273 132.421 108.111 133.051 109.833C133.68 111.555 140.881 113.121 146.209 112.185C151.536 111.248 152.005 106.545 151.38 103.251C150.756 99.958 149.814 80.6968 149.814 80.0875C149.814 79.4782 149.306 78.8035 148.525 77.8668Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M133.479 110.448C133.479 110.448 138.011 114.522 143.349 114.209C148.687 113.897 150.086 110.448 150.086 110.448C150.086 110.448 150.555 108.882 144.447 107.472C138.338 106.062 133.479 110.448 133.479 110.448Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M131.21 42.2875C139.45 42.2875 146.131 35.073 146.131 26.1735C146.131 17.274 139.45 10.0596 131.21 10.0596C122.97 10.0596 116.29 17.274 116.29 26.1735C116.29 35.073 122.97 42.2875 131.21 42.2875Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M131.205 40.4935C140.516 40.4935 148.065 33.2791 148.065 24.3796C148.065 15.4801 140.516 8.26562 131.205 8.26562C121.894 8.26562 114.346 15.4801 114.346 24.3796C114.346 33.2791 121.894 40.4935 131.205 40.4935Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M137.657 9.49512C138.231 16.8874 136.388 29.3153 119.786 36.2342C122.947 38.9978 127.008 40.5127 131.206 40.4943C140.517 40.4943 148.066 33.2833 148.066 24.3804C148.066 17.6679 143.765 11.9122 137.657 9.49512Z",
    fill: "#D5E6FB"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M131.205 40.4935C140.516 40.4935 148.065 33.2791 148.065 24.3796C148.065 15.4801 140.516 8.26562 131.205 8.26562C121.894 8.26562 114.346 15.4801 114.346 24.3796C114.346 33.2791 121.894 40.4935 131.205 40.4935Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M114.126 23.4851C115.155 23.4851 115.989 22.651 115.989 21.622C115.989 20.593 115.155 19.7588 114.126 19.7588C113.097 19.7588 112.263 20.593 112.263 21.622C112.263 22.651 113.097 23.4851 114.126 23.4851Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M114.125 22.7387C114.742 22.7387 115.243 22.2382 115.243 21.6208C115.243 21.0034 114.742 20.5029 114.125 20.5029C113.507 20.5029 113.007 21.0034 113.007 21.6208C113.007 22.2382 113.507 22.7387 114.125 22.7387Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M130.993 37.9565C138.616 37.9565 144.796 32.7801 144.796 26.3948C144.796 20.0094 138.616 14.833 130.993 14.833C123.37 14.833 117.19 20.0094 117.19 26.3948C117.19 32.7801 123.37 37.9565 130.993 37.9565Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M119.861 20.8393V26.2123L120.722 22.1284L123.084 27.0734V21.4839L132.335 34.8081L125.889 19.9782H128.91L126.76 18.0446L130.627 16.972L125.688 16.5439C125.688 16.5439 121.795 17.6165 119.861 20.8393Z",
    fill: "#D5E6FB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M159.235 46.3963L159.643 46.628C161.788 47.8365 171.729 53.5217 174.115 56.105C176.764 59.0055 170.59 63.2958 165.288 64.5547C159.985 65.8136 149.778 56.8654 148.263 55.0979C146.747 53.3304 145.362 43.8735 148.892 42.111C152.422 40.3486 159.235 46.3963 159.235 46.3963Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M174.119 56.1065C171.757 53.5232 161.792 47.838 159.647 46.6294L159.239 46.3978C159.239 46.3978 152.426 40.3551 148.896 42.1125C145.366 43.8699 146.756 53.3369 148.266 55.0993C149.858 56.7382 151.587 58.2392 153.433 59.5861L163.041 51.1665L174.482 58.7199C174.701 58.3008 174.784 57.8237 174.719 57.3551C174.654 56.8866 174.444 56.4501 174.119 56.1065Z",
    fill: "#D5E6FB"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M159.235 46.3963L159.643 46.628C161.788 47.8365 171.729 53.5217 174.115 56.105C176.764 59.0055 170.59 63.2958 165.288 64.5547C159.985 65.8136 149.778 56.8654 148.263 55.0979C146.747 53.3304 145.362 43.8735 148.892 42.111C152.422 40.3486 159.235 46.3963 159.235 46.3963Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M145.135 37.9466C145.959 37.1377 146.934 36.4993 148.005 36.0684C155.216 33.329 159.084 41.5622 160.428 47.192C160.428 47.192 158.746 48.5365 154.552 47.8618C150.357 47.187 144.314 44.3368 143.64 41.9852C143.222 40.5198 143.997 39.0746 145.135 37.9466Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M159.11 62.0318C159.11 62.0318 166.044 53.8389 170.964 53.713C175.884 53.5871 178.16 57.3689 177.656 60.3953C177.153 63.4217 173.371 66.8257 173.371 66.8257C173.371 66.8257 176.02 57.7616 172.107 57.7616C168.195 57.7616 159.11 62.0318 159.11 62.0318Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M156.584 63.9266C156.584 63.9266 164.908 57.1184 170.835 56.2372C176.762 55.356 178.892 62.5418 173.353 66.812C167.814 71.0822 164.143 72.8547 160.235 72.3511C156.328 71.8476 153.18 67.9651 156.584 63.9266Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M174.205 56.7275C174.29 58.1929 173.852 61.9444 167.759 64.5932C160.04 67.9519 158.489 67.962 158.489 67.962C158.718 69.2089 158.504 70.4967 157.884 71.6027C158.619 72.0041 159.421 72.2653 160.251 72.3732C164.159 72.8767 167.804 71.1143 173.369 66.834C177.664 63.4954 177.342 58.4195 174.205 56.7275Z",
    fill: "#D5E6FB"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M156.584 63.9266C156.584 63.9266 164.908 57.1184 170.835 56.2372C176.762 55.356 178.892 62.5418 173.353 66.812C167.814 71.0822 164.143 72.8547 160.235 72.3511C156.328 71.8476 153.18 67.9651 156.584 63.9266Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M162.509 71.0068C162.509 71.0068 174.594 65.9712 176.714 58.7451",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M153.562 66.5734C153.562 66.5734 155.073 64.5592 157.218 64.3024C159.364 64.0456 161.635 67.077 162.39 69.5998C163.145 72.1227 162.138 73.3816 161 73.7593C159.862 74.1369 153.562 66.5734 153.562 66.5734Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M160.998 73.7587C160.998 73.7587 161.758 71.3668 158.48 67.9628C155.202 64.5587 154.064 66.4521 151.163 68.0887C148.262 69.7252 147.255 72.6207 148.514 74.6349C149.773 76.6492 150.282 77.9131 154.053 78.5426C157.825 79.172 159.98 75.2644 159.98 75.2644C160.487 74.8991 160.848 74.3654 160.998 73.7587Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M155.661 73.3236C153.398 74.0728 151.075 74.6271 148.717 74.9803C149.84 76.8032 150.49 77.9614 154.06 78.5556C157.842 79.185 159.987 75.2774 159.987 75.2774C160.491 74.9091 160.848 74.3737 160.994 73.7667C160.994 73.7667 161.754 71.3748 158.476 67.9707C158.476 67.9657 159.358 71.9841 155.661 73.3236Z",
    fill: "#D5E6FB"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M160.998 73.7587C160.998 73.7587 161.758 71.3668 158.48 67.9628C155.202 64.5587 154.064 66.4521 151.163 68.0887C148.262 69.7252 147.255 72.6207 148.514 74.6349C149.773 76.6492 150.282 77.9131 154.053 78.5426C157.825 79.172 159.98 75.2644 159.98 75.2644C160.487 74.8991 160.848 74.3654 160.998 73.7587Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M159.992 75.2754C159.992 75.2754 157.091 77.0429 155.324 77.1688L159.992 75.2754Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M159.992 75.2754C159.992 75.2754 157.091 77.0429 155.324 77.1688",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0637 157.638C76.0637 157.638 71.3655 154.285 75.7314 149.919C80.0972 145.553 83.1136 146.56 84.7954 142.532C86.4773 138.503 88.1492 131.121 100.572 126.755C112.995 122.389 125.413 126.085 131.455 130.446C137.498 134.807 148.576 137.833 154.619 137.164C160.662 136.494 168.049 142.532 169.056 147.905C170.063 153.278 172.078 153.947 173.085 154.954C174.092 155.962 175.099 158.646 175.099 158.646H83.7883C83.7883 158.646 78.4153 159.32 76.0637 157.638Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M162.217 142.591C162.217 142.591 165.087 146.891 163.294 150.482C161.502 154.072 158.259 154.067 158.259 154.067",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M156.837 151.917C156.837 151.917 156.837 153.347 151.801 155.145",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M109.674 156.57C108.087 157.018 106.979 157.295 106.979 157.295",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M126.038 140.571C124.376 141.961 122.583 143.844 122.045 145.818C120.972 149.761 122.765 150.481 119.894 152.632C118.298 153.83 114.486 155.149 111.419 156.061",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M129.22 138.285C129.22 138.285 128.535 138.688 127.583 139.368",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M113.791 150.841C113.791 150.841 108.755 154.069 104.465 155.504C100.175 156.939 90.4761 154.426 90.4761 154.426",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0986 151.963C87.3552 151.148 85.8528 149.896 84.7378 148.327",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0603 153.349C93.0966 153.263 92.1446 153.076 91.2202 152.79",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M119.71 73.3756C115.646 69.9564 112.131 70.3543 110.112 71.0844C109.79 72.7361 109.573 73.7936 109.523 73.9497C109.206 74.8913 110.46 77.8674 114.377 82.0973C116.881 84.7899 120.172 86.6228 123.779 87.3343C124.751 83.5526 124.947 77.7868 119.71 73.3756Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M105.137 125.647C105.137 125.647 97.7595 129.555 97.5832 133.795C97.407 138.035 101.813 138.024 106.647 136.771C111.482 135.517 117.766 130.345 118.864 129.877C119.961 129.409 123.718 127.213 122.938 124.081C122.157 120.949 117.902 117.973 117.902 117.973L105.137 125.647Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M123.039 124.396C118.82 127.453 109.443 134.009 105.289 135.203C104.005 135.615 102.642 135.72 101.31 135.509C99.9777 135.298 98.7138 134.778 97.6196 133.989C97.6196 138.018 101.92 138.018 106.684 136.769C111.538 135.515 117.802 130.344 118.9 129.875C119.998 129.407 123.503 127.357 123.039 124.396Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6722 108.259C96.6722 108.259 101.683 124.373 103.561 125.959C105.439 127.545 113.431 126.271 113.431 126.271C113.431 126.271 115.153 129.408 116.407 130.803C117.661 132.198 121.442 131.115 121.578 127.198C121.714 123.28 119.383 117.801 119.383 117.801L114.06 103.072C114.06 103.072 107.791 101.818 101.975 103.072C96.1586 104.326 96.6722 108.259 96.6722 108.259Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M121.577 127.212C121.734 123.294 119.382 117.816 119.382 117.816L114.059 103.086C110.735 102.499 107.344 102.387 103.988 102.754C102.721 103.172 101.42 103.48 100.101 103.676C99.0839 104.066 98.1939 104.728 97.5273 105.589C98.8618 106.017 100.383 106.47 101.969 106.893C107.004 108.238 108.681 106.224 109.688 110.252C110.695 114.281 111.833 122.489 113.445 126.27C113.445 126.27 115.167 129.408 116.421 130.802C117.675 132.197 121.421 131.13 121.577 127.212Z",
    fill: "#D5E6FB"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6722 108.259C96.6722 108.259 101.683 124.373 103.561 125.959C105.439 127.545 113.431 126.271 113.431 126.271C113.431 126.271 115.153 129.408 116.407 130.803C117.661 132.198 121.442 131.115 121.578 127.198C121.714 123.28 119.383 117.801 119.383 117.801L114.06 103.072C114.06 103.072 107.791 101.818 101.975 103.072C96.1586 104.326 96.6722 108.259 96.6722 108.259Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M119.539 125.573C119.699 126.448 119.748 127.34 119.685 128.227",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M112.296 106.818C112.296 106.818 117.518 116.89 119.205 123.939",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0473 100.74C96.0473 100.74 93.7007 103.716 95.1106 107.317C96.5206 110.917 102.16 111.849 107.015 110.136C111.869 108.424 114.533 104.184 113.909 101.994C113.284 99.8034 96.0473 100.74 96.0473 100.74Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M123.301 86.1718C123.301 86.1718 117.036 100.584 112.963 103.56C108.889 106.536 99.8046 106.692 96.5164 103.086C93.2281 99.4809 97.1408 91.0261 101.215 84.4546C105.288 77.8832 107.323 72.2382 111.865 72.5504C116.407 72.8627 123.93 78.4925 123.301 86.1718Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.49
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M109.338 99.8437C105.813 102.81 101.069 103.726 97.519 103.953C101.376 106.642 109.252 106.269 112.963 103.56C117.037 100.584 123.301 86.172 123.301 86.172C123.434 84.5186 123.195 82.8564 122.601 81.3076C120.834 84.5405 114.711 95.3116 109.338 99.8437Z",
    fill: "#D5E6FB"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M123.301 86.1718C123.301 86.1718 117.036 100.584 112.963 103.56C108.889 106.536 99.8046 106.692 96.5164 103.086C93.2281 99.4809 97.1408 91.0261 101.215 84.4546C105.288 77.8832 107.323 72.2382 111.865 72.5504C116.407 72.8627 123.93 78.4925 123.301 86.1718Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M109.225 104.175C108.657 104.537 108.051 104.836 107.417 105.066",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M121.296 87.4668C119.352 91.6111 115.706 98.5451 111.436 102.468",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M122.808 84.0459C122.808 84.0459 122.465 84.9019 121.846 86.2767",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceman);
export default __webpack_public_path__ + "static/media/Spaceman.5dec1b9ef201150244c19f404c45ffa9.svg";
export { ForwardRef as ReactComponent };